import { Box, Grid, Stack, useMediaQuery, useTheme } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import LoadingTypography from "components/skeleton/LoadingTypography";
import PaperBox from "components/PaperBox"


const LoadingDocuments = (props: any) => {
  const theme = useTheme();
  const { hasAccordionWrapper } = props;
  const isPhone = useMediaQuery(theme.breakpoints.down("lg"));
  const numberOfSkeletonItems = [1, 2, 3, 4, 5];

  return (
    <PaperBox {...props}>
      {hasAccordionWrapper && isPhone ? (
        <Grid container direction="row" justifyContent="flex-start">
          <Grid item xs={12}>
            <LoadingTypography variant="bodySmall" />
            <LoadingTypography variant="bodySmall" />
          </Grid>
        </Grid>
      ) : (
        <Box >
          {numberOfSkeletonItems.map((item) => (
            <Box
              key={item}
            >
              <Grid
                container
                direction="row"
                alignItems="center"
                paddingBottom={2}
                spacing={0}
                justifyContent="space-between"
                style={{ color: "inherit", textDecoration: "inherit" }}
              >
                <Grid item xs={12} md={4} lg={5}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Skeleton animation="wave" width={20} height={20} />
                    <LoadingTypography variant="bodyMedium" />
                  </Stack>
                </Grid>

                <Grid item xs={4} md={3} lg={2}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <LoadingTypography variant="bodyMedium" />
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>
      )}
    </PaperBox>
  );
};

export default LoadingDocuments;
